export const OrderStatusTypeEnum = {
  PLANNING: 0,
  UNASSIGNED: 100,
  RESCHEDULED: 105,
  ALLOCATED: 110,
  RECEIVED_IN_FIELD: 120,
  LOADED: 130,
  ARRIVED: 140,
  STARTED: 150,
  PARTIAL: 155,
  COMPLETED: 160,
  COMPLETED_BY_SUPERVISOR: 165,
  CANCELLED: 200,
  LOAD_EXCEPTION: 300,
  EXCEPTION: 310,
  DELETED: 400,
}

export const ViewOnlyOrderStatuses = [105, 160, 165, 200]

// 160: Completed, 165: CompletedBySupervisor, 200: Cancelled, 310: Delivery Exception
export const CompletedOrderStatuses = [160, 165, 200, 310]

// reverse mapping number to string
export const OrderStatusTypeString = {
  0: 'Planning',
  100: 'Unassigned',
  105: 'Rescheduled',
  110: 'Allocated',
  120: 'Received in Field',
  130: 'Loaded',
  140: 'Arrived',
  150: 'Started',
  155: 'Partial',
  160: 'Completed',
  165: 'Completed by Supervisor',
  200: 'Cancelled',
  300: 'Load Exception',
  310: 'Exception',
  400: 'Deleted',
}

export type OrderStatusType = keyof typeof OrderStatusTypeString